import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { lpForm } from 'lp-form'
import {
  Field,
  propTypes as formPropTypes,
  formValueSelector,
} from 'redux-form'
import {
  persistSubmitSucceeded,
  formatObjectsToIds,
  parseIdsToObjects,
  replaceResources,
  serializeOptions,
} from 'utils'

import { CheckboxGroup, CheckboxFieldset } from 'components'
import { InputError, SubmitButton } from 'lp-components'
import { modifyProps } from 'lp-hoc'

const propTypes = {
  ...formPropTypes,
  standardTypes: PropTypes.arrayOf(Types.communityEnumerable).isRequired,
  arialabelledby: PropTypes.string.isRequired,
}

const defaultProps = {}

const GROUP_CHECKBOX_ERROR_NAME = 'school-multiple-standards-checkbox-group'

function MultipleStandardsForm({
  handleSubmit,
  isSaving,
  standardTypes,
  saved,
  submitting,
  error,
  ariaLabelledby,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <CheckboxFieldset
        invalid={!!error}
        disabled={isSaving}
        groupValidationErrorId={GROUP_CHECKBOX_ERROR_NAME}
      >
        <Field
          name="standards"
          aria-labelledby={ariaLabelledby}
          label={false}
          component={CheckboxGroup}
          options={serializeOptions(standardTypes)}
          format={formatObjectsToIds('standardId')}
          parse={parseIdsToObjects('standardId')}
        />
        {error && (
          <InputError
            name={GROUP_CHECKBOX_ERROR_NAME}
            error={error}
            touched
            invalid
          />
        )}
      </CheckboxFieldset>
      <div className="button-wrapper">
        <SubmitButton {...{ pristine: saved, submitting }}>
          Save Response
        </SubmitButton>
      </div>
    </form>
  )
}

MultipleStandardsForm.propTypes = propTypes
MultipleStandardsForm.defaultProps = defaultProps

const select = formValueSelector('school-multiple-standards')

function mapStateToProps(state) {
  return {
    standards: select(state, 'standards'),
  }
}

function modifyBeforeSubmit({ initialValues }) {
  return {
    beforeSubmit: ({ standards }) => {
      const resources = replaceResources({
        old: initialValues.standards,
        new: standards,
      })
      return { standards: resources }
    },
  }
}

export default compose(
  connect(mapStateToProps),
  modifyProps(modifyBeforeSubmit),
  lpForm({
    name: 'school-multiple-standards',
    enableReinitialize: true,
  }),
  persistSubmitSucceeded()
)(MultipleStandardsForm)
